import { useState } from "react";

import Image from "next/image";

import { INotification } from "shared/components/organisms/AppNotification/@types";
import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";
import { formatTimeAgo } from "shared/components/organisms/AppNotification/utils/formatTimeAgo";

import { ConsolePageForm } from "@Console/components/molecules/ConsolePageForm";

import { ICommentOnTicketNotificationMetadataProps } from "../../../@types/commentOnTicketNotificationTypes";
import NotificationTicketIcon from "../../../assets/icons/NotificationTicketIcon";
import {
  CommentOnTicketNotificationContainer,
  CommentOnTicketNotificationImageFallback,
  NotificationTicketCommentContainer,
} from "./styles";
import { useCommentOnTicketNotification } from "./useCommentOnTicketNotification";

interface ICommentOnTicketNotificationProps {
  notification: INotification<ICommentOnTicketNotificationMetadataProps>;
}

export const CommentOnTicketNotification = ({
  notification,
}: ICommentOnTicketNotificationProps) => {
  const [imageFailedToLoad, setImageFailedToLoad] = useState(false);

  const { user, transaction, notificationResult, comment, ticket } =
    useCommentOnTicketNotification(notification);

  return (
    <CommentOnTicketNotificationContainer className={ticket?.type}>
      <Notification.Container wasReaded={!!notification?.read_at}>
        <Notification.IllustrationContainer>
          {user?.photo && !imageFailedToLoad ? (
            <Image
              alt=""
              src={user?.photo}
              width={32}
              height={32}
              onError={() => setImageFailedToLoad(true)}
            />
          ) : (
            <CommentOnTicketNotificationImageFallback>
              <NotificationTicketIcon />
            </CommentOnTicketNotificationImageFallback>
          )}
        </Notification.IllustrationContainer>

        <Notification.Title.Container>
          <Notification.Title.Text>
            {notificationResult?.contentTitle}
          </Notification.Title.Text>
        </Notification.Title.Container>

        <NotificationTicketCommentContainer>
          {comment.comment}
        </NotificationTicketCommentContainer>

        {!!transaction?.uuid_order && (
          <a href={notificationResult?.ticketLink}>
            <ConsolePageForm.Button
              id="notification-go-to-ticket"
              variant="light"
            >
              Ver detalhes
            </ConsolePageForm.Button>
          </a>
        )}

        <Notification.Footer.Container>
          <Notification.Footer.Text>
            {formatTimeAgo(notification?.created_at)}
          </Notification.Footer.Text>

          <Notification.Footer.Dot />

          <Notification.Footer.Text>
            Ticket #{notificationResult?.ticketId}
          </Notification.Footer.Text>
        </Notification.Footer.Container>
      </Notification.Container>
    </CommentOnTicketNotificationContainer>
  );
};
